export const GET_CHAT_WIDGET = "GET_CHAT_WIDGET"
export const UPDATE_CHAT_WIDGET = "UPDATE_CHAT_WIDGET"
export const SET_CHAT_WIDGET = "SET_CHAT_WIDGET"
export const SET_LOADING = "SET_LOADING"
export const SET_AVATAR = "SET_AVATAR"